import confetti from "canvas-confetti";

export const fireSuccessConfetti = () => {
  const colors = ["#143887", "#00D9F5", "#00F5A0", "#FFB800", "#FF6B6B"];

  confetti({
    particleCount: 120,
    spread: 90,
    startVelocity: 45,
    origin: { y: 0.6 },
    colors,
  });

  confetti({
    particleCount: 60,
    angle: 60,
    spread: 70,
    origin: { x: 0, y: 0.7 },
    colors,
  });

  confetti({
    particleCount: 60,
    angle: 120,
    spread: 70,
    origin: { x: 1, y: 0.7 },
    colors,
  });
};
